import {
  RECEIVE_PAYMENT,
  START_PUBLISH_PRODUCT,
  PUBLISH_PRODUCT,
  PUBLISH_PRODUCT_SUCCESS,
  PUBLISH_PRODUCT_FAILURE,
  RESET_PUBLISH_PRODUCT_ERRORS,
  SEND_PUBLISH_DATA,
  SEND_PUBLISH_DATA_SUCCESS,
  SEND_PUBLISH_DATA_FAILURE,
  REQUEST_PRODUCT,
  RECEIVE_PRODUCT,
  NOT_RECEIVE_PRODUCT,
} from '../../constants/ActionTypes';
import { updateAttractions } from './publishingInitialState';

export default function publishingProductReducer(state, action) {
  switch (action.type) {
    case RECEIVE_PAYMENT:
      return {
        ...state,
        isFetching: false,
      };

    case START_PUBLISH_PRODUCT:
      return {
        ...state,
        isPublishing: true,
      };

    case PUBLISH_PRODUCT:
      return {
        ...state,
        isSaving: true,
        isNotSaved: false,
        isSaved: false,
      };

    case PUBLISH_PRODUCT_SUCCESS:
      return {
        ...state,
        receivedPublishData: {
          ...state.receivedPublishData,
          status: 'waiting_for_moderation',
        },
        isSaving: false,
        isNotSaved: false,
        isSaved: true,
      };

    case PUBLISH_PRODUCT_FAILURE:
      return {
        ...state,
        isSaving: false,
        isSaved: false,
        errors: [...state.errors, ...action.errors],
        isNotSaved: true,
      };

    case RESET_PUBLISH_PRODUCT_ERRORS:
      return {
        ...state,
        isPublishing: false,
        errors: [],
      };

    case SEND_PUBLISH_DATA:
      return {
        ...state,
        isSaving: true,
        isSaved: false,
      };

    case SEND_PUBLISH_DATA_SUCCESS:
      return {
        ...state,
        receivedPublishData: { ...action.data },
        attractions: updateAttractions(action.data, state.attractions),
        isSaving: false,
        isSaved: true,
        isNotSaved: false,
      };

    case SEND_PUBLISH_DATA_FAILURE:
      return {
        ...state,
        isSaving: false,
        isSaved: false,
        errors: [...state.errors, ...action.errors],
        isNotSaved: true,
      };

    case REQUEST_PRODUCT:
      return {
        ...state,
        isFetching: true,
      };

    case RECEIVE_PRODUCT:
      return {
        ...state,
        isFetching: false,
        receivedPublishData: {
          ...action.data,
          subcategories: action.data.subcategories.map((x) => x.id),
        },
        inclusions: action.data.inclusions,
        exclusions: action.data.exclusions,
        highlights: action.data.highlights,
        priceLevels: action.data.priceLevels,
        attractions: updateAttractions(action.data, state.attractions),
        tickets: action.data.tickets,
      };

    case NOT_RECEIVE_PRODUCT:
      return {
        ...state,
        isFetching: false,
        errors: [...state.errors, ...action.errors],
      };

    default:
      return state;
  }
}
